import { ELSCommonUIConstants } from 'components/common';
import { lazy } from 'react';
var SessionTimedOutPage = lazy(function () { return import('components/features/session-timed-out/SessionTimedOutPage'); });
export var TimeoutRoutes = {
    getRoutes: function () { return [
        {
            path: "/".concat(ELSCommonUIConstants.security.States.TimedOut),
            component: SessionTimedOutPage,
            isPrivate: false
        }
    ]; }
};
